// Shared helpers for schedule rendering + dates.
export const STATUS_META = {
  working: { label: "Work", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  off_weekly: { label: "Off", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  off_sunday: { label: "Sun Off", cls: "bg-violet-100 text-violet-800 border-violet-300" },
  off: { label: "Off", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  off_cancelled: { label: "Off✗", cls: "bg-rose-100 text-rose-700 border-rose-300" },
  public_holiday: { label: "PH", cls: "bg-sky-100 text-sky-700 border-sky-300" },
};

export const WEEKDAYS = [
  { key: "tue", label: "Tuesday" },
  { key: "wed", label: "Wednesday" },
  { key: "thu", label: "Thursday" },
  { key: "fri", label: "Friday" },
  { key: "sat", label: "Saturday" },
];

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const addDays = (iso, n) => {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
export const isSunday = (iso) => new Date(iso + "T00:00:00").getDay() === 0;
